import { Select } from "antd";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import FormItem from "@/components/FormItem";
import { NAMESPACES } from "@/constants/i18next.constants";
import { filterOption } from "@/utils/filterOption";

import { TBillingOnboardingForm, TGetInstallation } from "../../MultiStepForm.types";

type TFourthStepProps = {
  installationList?: TGetInstallation[];
  control: Control<TBillingOnboardingForm>;
};

function FourthStep({ control, installationList }: TFourthStepProps) {
  const { t } = useTranslation([NAMESPACES.BILLING_ONBOARDING]);

  return (
    <FormItem
      name="installationReference"
      control={control}
      label={t(
        "billingOnboarding.installationReferenceLabel",
      )}
    >
      <Select
        showSearch
        filterOption={filterOption}
        options={installationList}
        placeholder={t(
          "billingOnboarding.installationReferencePlaceholder",
        )}
      />
    </FormItem>
  );
}

export default FourthStep;
